import { render, staticRenderFns } from "./PatientDoctor.vue?vue&type=template&id=8f8e0d1e"
import script from "./PatientDoctor.vue?vue&type=script&lang=js"
export * from "./PatientDoctor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports